import { LABELS } from '@/constants/common/message.constants'
import type { SiteWithAreaEntity, SiteEntity } from '@/libs/api'

export const mapToSiteFieldName = (site: SiteWithAreaEntity | SiteEntity) => {
  return `${site.code}/${site.name}${site.isArea ? LABELS.AREA_WITH_PARENTHESES : ''}`
}
